import { API_AUTH } from "./common";

const GuiTinNhanApi = {
  guiTinNhan: ({ SoDienThoai, TenNguoiNhan, NoiDung, ChoVayID }) =>
    API_AUTH.post(`he-thong/gui-sms-hop-dong`, {
      TenNguoiNhan,
      NoiDung,
      ChoVayID,
      SoDienThoai,
    }),
};

export default GuiTinNhanApi;
